/*
  Mantiene la ficha tecnica sincronizada con el selector de variante.

  Se apoya en el evento que ya publica Dawn (assets/product-info.js):
  publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId, html, variant } }).
  Hoy los productos tienen una sola variante, asi que esto no hace nada visible;
  existe para que el dia que D2 unifique 750 ml y 50 ml en un solo producto,
  el volumen cambie con el selector sin tocar la seccion.
*/
if (!customElements.get('dm-product-specs')) {
  customElements.define(
    'dm-product-specs',
    class DmProductSpecs extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant) return;
          this.renderVariant(variant.id);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      renderVariant(variantId) {
        if (this.currentVariantId === String(variantId)) return;
        this.currentVariantId = String(variantId);

        const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.sectionId}`;

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const parsed = new DOMParser().parseFromString(responseText, 'text/html');
            const source = parsed.querySelector('.dm-specs__grid');
            const destination = this.querySelector('.dm-specs__grid');
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }
    }
  );
}
